<i18n>
{
  "de": {
    "imprint": "Impressum",
    "tos": "AGB",
    "privacy": "Datenschutz"
  },
  "en": {
    "imprint": "Imprint",
    "tos": "Terms of Service",
    "privacy": "Privacy Policy"
  }
}
</i18n>

<template>
  <div class="artist-legal-line has-text-grey-light py-3 px-5">
    <div class="container">
      <p
        v-if="artist"
        class="has-text-grey-light"
      >
        {{ artist.nickname }}<br>
        <nuxt-link
          :to="localePath({
            name: 'id-profile-imprint',
            params: { id: artist.urlAlias }
          })"
        >
          {{ $t('imprint') }}
        </nuxt-link><br>
        <nuxt-link
          v-if="hasTOS"
          :to="localePath({
            name: 'id-profile-tos',
            params: { id: artist.urlAlias }
          })"
        >
          {{ $t('tos') }}
        </nuxt-link><br>
        <nuxt-link
          v-if="hasPrivacy"
          :to="localePath({
            name: 'id-profile-privacy',
            params: { id: artist.urlAlias }
          })"
        >
          {{ $t('privacy') }}
        </nuxt-link>
      </p>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  name: 'artistLegalLinks',
  computed: {
    hasLegal() {
      return this.artist &&
        this.artist.profile &&
        this.artist.profile.configuration &&
        this.artist.profile.configuration.legal
    },
    hasTOS() {
      if (!this.hasLegal) {
        return false
      }
      return this.artist.profile.configuration.legal.tos &&
        this.artist.profile.configuration.legal.tos !== ''
    },
    hasPrivacy() {
      if (!this.hasLegal) {
        return false
      }
      return this.artist.profile.configuration.legal.privacy &&
        this.artist.profile.configuration.legal.privacy !== ''
    },
    ...mapState(['artist'])
  }
}
</script>
<style lang="scss">
.artist-legal-line {
  width: 100%;
  background-color: #052D40;

  a {
    color: white;

    &.hover {
      text-decoration: underline;
    }
  }
}
</style>
